import { opinions } from '../defaults/opinions';

export const germknoedel = {
	name: '4 Germknödel mit Sauerkirschfüllung',
	desc: 'dazu Apfelmus und Vanille-Sahnesauce.',
	image: 7,
	opinions: [
		{
			name: 'Jane Doe',
			date: '14. Januar 2017',
			title: 'Wie beim Skifahren',
			content: 'Ich kenne und liebe Germknödel vom Skifahren. Ich glaube sie passen zu keiner besonderen Ernährung, aber hin und wieder muss das auch mal!',
			rating: 5,
		},
		...opinions,
	],
	warnings: ['gluten', 'zucker'],
	ingredients: [
		{'Weizenmehl': 'weizen, gluten'}, 
		'Wasser', 
		'Pflaumen',
		{'Zucker': 'zucker'},
		{'Hefe': 'hefe'},
		{'Vollmilch': 'milch, laktose'},
		{'Ei': 'ei'},
		{'Eiklar': 'ei'},
		'Rapsöl',
		'Salz',
		'Zitronenextrakt',
		'Mohn',
		'Vanillearoma',
	],
};



// WEBPACK FOOTER //
// ./src/dishes/single-dishes/germknoedel.js